"use client";
import {NeoHeader} from "@/components/shared";
import {useNeoContext} from "@/context/neo/neo.context";
import {useCallback, useState} from "react";
import {BillingHistory} from "./billinghistory";
import {CreditsPointsUsages} from "./creditspointsusages";

export const CreditsPointsOverview = () => {
  const {filterContext, offset} = useNeoContext();
  const [loginUserId, setLoginUserId] = useState<string>("");
  const [activeTab, setActiveTab] = useState("creditusage");
  const tabs = [
    {id: "creditusage", label: "Credits Usage"}
    //{id: "billinghistory", label: "Billing History"}
  ] as const;

  const onTabClick = useCallback((id: any) => {
    setActiveTab(id);
  }, []);

  return (
    <div className="flex w-full flex-col p-2">
      <div className="mb-4 flex flex-col items-start font-semibold">
        <NeoHeader message="Credits Overview"></NeoHeader>
        <h6 className="mt-1 text-sm text-gray-400">
          Track and optimize your credit usage
        </h6>
      </div>
      <div className="flex gap-1 overflow-hidden rounded-xl border border-gray-200 p-1">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => onTabClick(tab.id)}
            className={`flex-1 rounded-xl py-2 text-sm font-medium transition-colors ${activeTab === tab.id ? "bg-black text-white" : ""}`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {activeTab === "creditusage" && <CreditsPointsUsages />}
      {activeTab === "billinghistory" && <BillingHistory />}
    </div>
  );
};
